import { Injectable } from '@angular/core';

@Injectable()
export class SmartenitCurrencyService {
  public static readonly DEFAULT_CURRENCY = '$';

  private _currency: string = SmartenitCurrencyService.DEFAULT_CURRENCY;
  public get currency() {
    return this._currency;
  }
  public set currency(value: string) {
    this._currency = value;
  }
}
